import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

import { Subject } from 'rxjs';

@Component({
  selector: 'app-student-additional-panel',
  templateUrl: './student-additional-panel.component.html',
  styleUrls: ['./student-additional-panel.component.scss']
})
export class StudentAdditionalPanelComponent implements OnChanges, OnDestroy {
  @Input() profileData: any;
  additionalFormsTouched = false;
  seeMyself = '';
  lyfAboutYou = '';
  lifeJson: any;

  private destroyed$ = new Subject();

  constructor(
    private commonDataSharedService: CommonDataSharedService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['profileData'] !== undefined && changes['profileData'].currentValue !== undefined) {
      this.setLifeData(changes['profileData'].currentValue || {});
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.additionalFormsTouched = false;
  }

  seeMySelfChange(event) {
    this.additionalFormsTouched = true;
    this.seeMyselfEvent(event.target.value);
    this.commonDataSharedService.studentQuestionaryThreeCloseFlag.next(true);
  }

  seeMyselfEvent(item: any) {
    const obj = {seeMyself: item};
    this.commonDataSharedService.studentQuestionaryThreeSeeMySelfData.next(obj);
  }

  lyfAboutYouChange(event) {
    this.additionalFormsTouched = true;
    this.lyfAboutYouEvent(event.target.value);
    this.commonDataSharedService.studentQuestionaryThreeCloseFlag.next(true);
  }

  lyfAboutYouEvent(item: any) {
    const obj = {lyfAboutYou: item};
    this.commonDataSharedService.studentQuestionaryThreelyfAboutYouData.next(obj);
  }

  setLifeData(lifeJson) {
    if (lifeJson) {
      this.lifeJson = lifeJson;
      this.seeMyself = this.lifeJson.seeMyself;
      this.lyfAboutYou = this.lifeJson.otherInformation;
      this.seeMyselfEvent(this.seeMyself);
      this.lyfAboutYouEvent(this.lyfAboutYou);
    }
  }

}
